module.exports = __webpack_public_path__ + "img/3.661434e5.png";